import { cx } from 'utils';

/**
 * Spinner — indeterminate loading indicator. Tuned for light surfaces with a
 * brand leading edge. `size` is in px; `tone` swaps the accent. Use `tone`
 * "white" on solid coloured buttons, "brand" on white surfaces.
 */
const TONES = {
  brand: 'border-slate-200 border-t-brand-600',
  teal: 'border-slate-200 border-t-teal-500',
  slate: 'border-slate-200 border-t-slate-500',
  white: 'border-white/40 border-t-white',
};

export default function Spinner({ className = '', size = 24, tone = 'brand', ...props }) {
  return (
    <span
      role="status"
      aria-label="Loading"
      style={{ width: size, height: size }}
      className={cx(
        'inline-block animate-spin rounded-full border-2',
        TONES[tone] || TONES.brand,
        className
      )}
      {...props}
    />
  );
}
